export default __webpack_public_path__ + "static/media/267.7d73bb76.jpg";